export const MAX_MESSAGE_LENGTH = 2000
export const CONTAINER_HEIGHT = 300
export const AVATAR_SIZE = 32
